import type { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import type { ReactNode } from 'react';
import { Spinner, type SpinnerComponentProps } from './Spinner';
import type { SpinnerLoaderProps } from './Spinner.Loader';

export interface StandaloneSpinnerProps extends StandaloneComponentProps {
  loader?: ReactNode;
  options?: SpinnerComponentProps & {
    $loader?: SpinnerLoaderProps;
  };
}

export const StandaloneSpinner: StandaloneComponent<StandaloneSpinnerProps> = ({ loader, options, ...props }) => {
  const { $loader: loaderProps, ...baseProps } = options ?? {};
  return (
    <Spinner {...baseProps} {...props}>
      <Spinner.Loader {...loaderProps}>{loader}</Spinner.Loader>
    </Spinner>
  );
};

export default StandaloneSpinner;
